import rules from "../../utils/rules";
import apiService from "../../api/api.service";
export default {
  name: "two-factor-login",
  data() {
    return {
      rules: rules,
      valid: false,
      authTypes: ["Email", "SMS"],
      selectedAuthenticationType: "Email",
      gettingAuthenticationCode: false,
      submittingAuthCode: false,
      mfaCode: null,
      alertType: "success",
      showAlert: false,
      alertMessage: null,
      hideMFACode: true,
    };
  },
  methods: {
    async getAuthenticationCodeClick() {
      this.showAlert = false;
      this.gettingAuthenticationCode = true;

      let payload = {
        mobileNumber:
          "+" +
          this.$store.getters.phoneCountryCode +
          this.$store.getters.phoneNumber,
        email: this.$store.getters.user,
        message: "",
        type: this.selectedAuthenticationType,
      };
      if (this.selectedAuthenticationType == "SMS") {
        payload.type = "Phone";
      }
      let response = await apiService.getMultifactorCode(payload);
      if (response.isSuccess) {
        if (this.selectedAuthenticationType == "Email") {
          this.alertType = "success";
          this.showAlert = true;
          this.alertMessage =
            "We've sent a 2FA code to your email: " +
            this.transformEntry(this.$store.getters.user, "email");
        } else {
          this.alertType = "success";
          this.showAlert = true;
          this.alertMessage =
            "We've sent a 2FA code to your number: " +
            this.transformEntry(this.$store.getters.phoneNumber, "phone");
        }
        this.gettingAuthenticationCode = false;
      } else {
        this.gettingAuthenticationCode = false;
        this.alertType = "error";
        this.showAlert = true;
        this.alertMessage =
          "Unable to get the 2FA code. Please try again later";
      }
    },
    async submitAuthCodeClick() {
      this.showAlert = false;
      if (this.$refs.form.validate()) {
        this.submittingAuthCode = true;
        let response = await apiService.validateMultifactorCode(this.mfaCode);
        if (response.isSuccess) {
          this.submittingAuthCode = false;
          //set two factor enabled as false
          this.$store.commit("SET_TWO_FACTOR_ENABLED", false);
          //redirect to home page
          this.$router.push("/");
        } else {
          this.submittingAuthCode = false;
          this.alertType = "error";
          this.showAlert = true;
          this.alertMessage = response.systemMessage;
        }
      }
    },
    transformEntry(item, type) {
      switch (type) {
        case "email":
          var parts = item.split("@"),
            len = parts[0].length;
          return item.replace(parts[0].slice(1, -1), "*".repeat(len - 2));
        case "phone":
          return item[0] + "*".repeat(item.length - 4) + item.slice(-3);
        default:
          throw new Error("Undefined type: " + type);
      }
    },
    backToLogin() {
      this.$store.dispatch("LogOut");
      this.$router.push("/login");
    },
  },
};
